module.exports = __webpack_public_path__ + "static/media/fvs_fremdlinge_37.3915a17d.jpg";